const israel = [
      { "name": "Center District", "code": "Center District" },
      { "name": "Tel Aviv District", "code": "Tel Aviv District" },
      { "name": "Jerusalem District", "code": "Jerusalem District" },
      { "name": "Haifa District", "code": "Haifa District" },
      { "name": " North District", "code": "North District" },
      { "name": "South District", "code": "South District" },
      { "name": "Judea and Samaria Area", "code": "Judea and Samaria Area" },
  ]
  export default israel;